var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1831(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reverse",
    transform: "scale(-1, 1) translate(-31.593118, 1)",
    fillRule: "evenodd",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "base",
    stroke: "#687577",
    strokeWidth: 1.96,
    fill: "#FFFFFF",
    transform: "translate(15.172992, 11.435583) scale(-1, 1) translate(-15.172992, -11.435583)",
    d: "M17.368022,22.8711658 C15.3138468,22.8711658 13.2625714,22.7170478 11.2314684,22.4103082 C9.24118857,22.0518635 4.2711268,19.9762976 1.61081462,15.8183383 C-1.24903805,11.3531406 0.400929517,6.77733711 1.24316809,5.01822674 C2.18005173,3.05907006 4.90289115,5.844214e-13 8.26808697,5.844214e-13 C8.31523866,5.844214e-13 8.36204868,5.844214e-13 8.40885869,5.844214e-13 C11.1422902,0.0682751938 14.0376774,3.26321289 15.2356038,4.74512597 C16.5503843,3.11198333 18.3479572,0.890649903 21.5628143,0.890649903 L21.648234,0.890649903 C24.9625197,0.930249515 26.2769585,1.94174651 26.9828672,2.48521705 L27.142773,2.60606415 C27.8527818,3.12461424 30.0029673,5.49922548 30.2752854,8.16468905 C30.4414059,10.5778076 30.3145171,13.0021452 29.8973885,15.3847908 C29.5967111,16.7844323 27.1885579,20.8468063 23.2879512,22.1406212 C21.618508,22.6936503 19.4341545,22.8711658 17.368022,22.8711658 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.406882, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hookstyle",
    transform: "scale(-1, -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hook",
    transform: "translate(-12.406882, -18.000000) translate(4.406882, 10.000000)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.58716581,4.86252597 C3.06706263,4.62380711 2.85229747,4.03585383 3.10747439,3.54929557 C3.36265132,3.06273731 3.99114002,2.86182379 4.5112432,3.10054265 C5.46056455,3.53626565 6.39450266,4.14450585 7.31484578,4.922185 C8.2443698,5.70762188 10.0438875,7.8539425 12.8028208,11.4459993 C13.1408693,11.8861293 13.0335172,12.4992928 12.5630432,12.8155382 C12.0925692,13.1317837 11.4371322,13.0313555 11.0990837,12.5912255 C8.44101017,9.13048544 6.68104531,7.03134029 5.90861111,6.37864246 C5.12699602,5.71818688 4.35258484,5.21384081 3.58716581,4.86252597 Z",
    id: "Path-7",
    transform: "translate(8.000000, 8.000000) scale(-1, 1) translate(-8.000000, -8.000000)"
  })))), /*#__PURE__*/React.createElement("line", {
    id: "extracted",
    x1: 3.72913171,
    y1: 3.66100902,
    x2: 23.386966,
    y2: 19.5966563,
    stroke: "none",
    strokeLinecap: "square"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1831);
export default __webpack_public_path__ + "static/media/18-31.6e76e70b4413653db2e9724886482afc.svg";
export { ForwardRef as ReactComponent };